import React from 'react';
import $ from 'jquery';
import Icon from '../Icons/Icon';
import ProgressBar from '../ProgressBar/ProgressBar';
import {ShareButtons, generateShareIcon} from 'react-share';

export default class ProductDetailInfo extends React.Component {
	constructor(props) {
		super(props);
		//this is just the Previous Price html that was removed. Keeping a reference to it here in case we want it back.
		//<span className="product-details-price-previous" aria-hidden="true">{this.props.ProductData.retailPrice}</span>
    }

    render() {
        //console.log('props-ProductData:');
        //console.log(this.props.ProductData);
        return (
            <div>
                <div className="product-details-area clearfix">
                    <h2 className="product-details-product-name primaryText" role="heading" tabIndex="0">
                        <span dangerouslySetInnerHTML={{ __html: this.props.ProductData.name }}></span>
                    </h2>
                    <h3 className="product-details-product-name productCode">
                        #{this.props.ProductData.productCode}
                    </h3>
                    <h3 className="product-details-product-subtitle" role="heading" tabIndex="0">
                        {this.props.ProductData.description}
                    </h3>

                    <div className="product-details-prices">
						<span className="product-details-price" tabIndex="0">
							{this.props.ProductData.actualPrice}

						</span>
					</div>
				<div className="product-details-additional-info">
					<div dangerouslySetInnerHTML={{__html: this.props.ProductData.singlePageResource}}/>
				</div>
					<div style={{clear: 'both'}}></div>
					<div className="shop-product"> 
						{<DetailSelections resources={this.props.resources} addToCart={this.props.addToCart.bind(this)} ProductData={this.props.ProductData} />}
					</div>
				</div>
            </div>
		)
	}
}

ProductDetailInfo.defaultProps = {
	ProductData: {}
}

class DetailSelections extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			quantity: 1,
			sections: [
				{
					"code": "details",
					"description": this.props.resources["PWS.ProductDetails.TabProductDetails"],
                    "content": this.props.ProductData.SinglePageResource
				},
				/*{
					"code": "video",
					"description": "Video",
					"content": "<div class='videoPlayBtn'><img src='images/videoPlayBtn.png' alt='playBtn'></div><img src='images/video-thumb-01.png' alt='video'></div>"
				},
				{
					"code": "anything",
					"description": "Anything",
					"content": "<table  width='100%' cellpadding=\"10\" cellspacing=\"4\" style=\"text-align: left;\"><thead><tr align=\"left\"><th>Column 1</th><th colspan=\"5\" align=\"left\" valign=\"bottom\">Column 2</th></thead></tr><tbody><tr align=\"left\" bgcolor=\"F0F0F0\"><td>Cool Beans</td><td>Another Column</td></tr></tbody></table>"
				}*/
			]
		}
	}

	handleChange() {
		this.setState({
			quantity: !isNaN(parseInt(this.refs.quantity.value)) && isFinite(this.refs.quantity.value) && (this.refs.quantity.value != 0) ? this.refs.quantity.value : 1
		})
	}

	decreaseQuantity() {
		this.setState({
			quantity: !isNaN(parseInt(this.refs.quantity.value)) && isFinite(this.refs.quantity.value) && (parseInt(this.refs.quantity.value) - 1 <= 0) ? 1 : parseInt(this.refs.quantity.value) - 1
		})
	}

	increaseQuantity() {
		this.setState({
			quantity: !isNaN(parseInt(this.refs.quantity.value)) && isFinite(this.refs.quantity.value) ? parseInt(this.refs.quantity.value) + 1 : 1
		})
	}

	hasStarted() {
		return this.props.ProductData.hasStarted !== undefined ? this.props.ProductData.hasStarted : true;
    }

	isProductExpired() {
		return this.props.ProductData.isExpired !== undefined ? this.props.ProductData.isExpired : false;
	}

	productHasQuantatiy() {
		return this.props.ProductData.available !== undefined ? this.props.ProductData.available > 0 : true;
    }

	getProductAvailable() {
		return this.hasStarted() && !this.isProductExpired() && this.productHasQuantatiy();
    }

	render(){

		let cartIcon = {
			Size: 24,
			Fill: '#333333',
            name: 'ShoppingBag'
		}

		let heartIcon = {
			Size: 26,
			Fill: '#333333',
			name: 'Heart'
		}
		//Wishlist Button was removed bc functionality has not been implemented
		/*<div className="wishlist-button-wrapper clearfix">
			<div className="wishlist-tooltip" style={{display: 'none', left: 150}}>{this.props.resources["PWS.ProductDetails.WishlistButton"]}</div>
			<button className="wishlist-button" type="button">
				<div className="inline-icon wishlist-sm white">
					<Icon iconData={heartIcon} styleClass="wishlist-button-icon" />
				</div>
				<span className="visuallyhidden">{this.props.resources["PWS.ProductDetails.WishlistButton"]}</span>
			</button>
		</div>*/

		let availablePercentage = this.props.ProductData.available > this.props.ProductData.productAvailableQuantityMaxThreshold ? 100 : this.props.ProductData.available / this.props.ProductData.productAvailableQuantityMaxThreshold * 100;
		let progressBarStyle = this.props.ProductData.available < this.props.ProductData.productAvailableQuantityLowThreshold ? "orange" : "green";
		let legendAvailable = this.props.ProductData.available > this.props.ProductData.productAvailableQuantityMaxThreshold  ?
			this.props.ProductData.productAvailableQuantityMaxThreshold + '+ ' + this.props.resources["ProductDetails.AvailableLimited.Text"] :
			this.props.ProductData.available + ' ' + this.props.resources["ProductDetails.AvailableLimited.Text"];

		let showProgressBar = ((!!window.jenkon.features.ShowInventoryProgressBar) && 
			this.props.ProductData.available !== undefined &&
			this.props.ProductData.available <= this.props.ProductData.productAvailableQuantityMaxThreshold);

		return (
			<div className="product-options-group clearfix">
				<div className="product-qty-wrapper clearfix">
					<div className="qty-buttons">
						<button onClick={this.decreaseQuantity.bind(this)} type="button" className="quantity-button">
							<span className="visuallyhidden">{this.props.resources["PWS.ProductDetails.DecreaseQuantityButton"]}</span>
							<span aria-hidden="true">-</span>
						</button>
						<label htmlFor="qty" className="visuallyhidden">{this.props.resources["PWS.ProductDetails.QuantityInputLabel"]}</label>
						<input value={this.state.quantity} type="text" ref="quantity" className="quantity-field" name="qty" id="qty" role="log" aria-live="assertive" onChange={this.handleChange.bind(this)} />
						<button onClick={this.increaseQuantity.bind(this)} type="button" className="quantity-button">
							<span className="visuallyhidden">{this.props.resources["PWS.ProductDetails.IncreaseQuantityButton"]}</span>
							<span aria-hidden="true">+</span>
						</button>
					</div>
				</div>
				<div className="product-details-buttons-wrapper clearfix">
					{this.getProductAvailable() &&
						<button type="button" className="twnew-default-button" onClick={this.props.addToCart.bind(this, this.state.quantity)}>
							<div className="button-icon shopping-cart white" style={{ margin: '0px!important' }}>
								<Icon iconData={cartIcon} />
							</div>

							{this.props.resources["PWS.Globals.AddToCartButton"]}
						</button>
					}
					{!this.hasStarted() && 
						<div className="availability-error">{this.props.resources["ProductDetails.OfferHasNotStarted.Text"]}</div>}
					{this.isProductExpired() &&
						<div className="availability-error">{this.props.resources["ProductDetails.OfferIsExpired.Text"]}</div>}
					<div style={{ clear: 'both' }}>&nbsp;</div>
                    {this.props.ProductData.available !== undefined && showProgressBar &&
                        <div className="social-icons clearfix">
                            <ProgressBar
                                progress={availablePercentage}
                                bgcolor={progressBarStyle}
                                legend={legendAvailable}
                            />
                        </div>
                    }

					<div id="social-icons-desktop" className="social-icons clearfix">
						<SocialIcons ProductData={this.props.ProductData} resources={this.props.resources} />
					</div>
				</div>
				<div id="social-icons-mobile" className="social-icons clearfix">
					<SocialIcons ProductData={this.props.ProductData} resources={this.props.resources} />
				</div>
				
							{/*<TabbedArea sections={this.state.sections} />*/}
							
			</div>
		)
	}
}

							    class SocialLinks extends React.Component {
							        constructor(props) {
							            super(props);
							        }

							        createSocialIcons(icons, i) {
							            let iconData = {
							                Size: 26,
							                Fill: '#333333',
							                name: icons.code + 'Circle'
							            }
							            return (
                                            <a key={i} className="social-icon" href={icons.socialUrl}>
                                                <Icon iconData={iconData} inline={true} />
                                                <span className="visuallyhidden">{icons.code}</span>
                                            </a>
                                        )
                                                }

							        render() {
							            if(!this.props.socialLinks || this.props.socialLinks.length === 0) return null;
							            return(
                                            <div>
                                                <div className="socialicons-share-text">{this.props.resources["PWS.ProductDetails.ShareLinksTitle"]}</div>
							            {this.props.socialLinks.map(this.createSocialIcons.bind(this))}
							            </div>
                                        )
	}
							    }

							    class SocialIcons extends React.Component {
							        constructor(props) {
							            super(props);
							        }

							        render() {
							            if(!this.props.ProductData.imageGallery) return null;
							            const FacebookIcon = generateShareIcon('facebook');
							            const TwitterIcon = generateShareIcon('twitter');
							            const PinterestIcon = generateShareIcon('pinterest');
										let shareURL = `${window.jenkon.consultantRoot}ProductDetails?ID=${this.props.ProductData.offerCode}`;
							            return (
                                            <div>
                                                <div className="socialicons-share-text">{this.props.resources["PWS.ProductDetails.ShareLinksTitle"]}</div>
                                                <ShareButtons.FacebookShareButton url={shareURL} quote={this.props.ProductData.name}>
                                                    <FacebookIcon size={32} round={true} iconBgStyle={{fill:"#3b5998"}} />
                                                </ShareButtons.FacebookShareButton>
                                                <ShareButtons.TwitterShareButton url={shareURL} title={this.props.ProductData.name}>
                                                    <TwitterIcon size={32} round={true} iconBgStyle={{fill:"#0084b4"}} />
                                                </ShareButtons.TwitterShareButton>
                                                <ShareButtons.PinterestShareButton url={shareURL} description={this.props.ProductData.name} media={`${window.jenkon.imageEndpoint}${this.props.ProductData.imageGallery.length > 0 ? this.props.ProductData.imageGallery[0].imageResourceKey : null}`}>
                                                    <PinterestIcon size={32} round={true} iconBgStyle={{fill:"#bd081c"}} />
                                                </ShareButtons.PinterestShareButton>
                                            </div>
                                        )
							    }
							    }

                                class TabbedArea extends React.Component {
                                    constructor(props) {
                                        super(props);

                                        this.state = {
							        selectedTab: 0
							    }

							    }

                                    selectTab(tab) {
                                        this.setState({
							        selectedTab: tab
							    })
							    }

                                    createTabs(tab, i) {
                                        let activeTab = i === this.state.selectedTab ? 'active' : '';
                                        return (
                                            <li key={i} role="presentation" className={activeTab}>
                                                <a href="javascript:void(0);" aria-controls={tab.code} role="tab" data-toggle="tab" onClick={this.selectTab.bind(this, i)}>{tab.description}</a>
                                            </li>
                                        )
							    }

                                    createPanels(panel, i) {
                                        if(i !== this.state.selectedTab) return;
                                        return (
                                            <div key={i}>
                                                <h4 style={{marginTop: -12}}>
							    {panel.description}
                                                </h4>
                                                <div dangerouslySetInnerHTML={{__html: panel.content}}></div>
                                            </div>
                                        )
							    }

                                    render() {
							        //if(!this.props.sections || this.props.sections.length === 0) return null;
                                        return(
                                            <div id="product-details-tabs" className="product-details-tabs tabbedArea">
                                                <ul className="nav nav-pills" role="tablist">
							    {this.props.sections.map(this.createTabs.bind(this))}
                                                </ul>

                                                <div className="product-details-tab-content" role="article" aria-live="polite">
                                                    <div role="tabpanel" className="tab-pane">
							    {this.props.sections.map(this.createPanels.bind(this))}
                                                    </div>
                                                </div>
                                            </div>
                                        )
							    }
							    }



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductDetail/ProductDetailInfo.js